"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const models_1 = require("../../utils/models");
const location_accordion_1 = __importDefault(require("../location-accordion"));
const utils_1 = require("../../utils/utils");
const location_filter_checkbox_1 = __importDefault(require("../location-filter-checkbox"));
const location_filter_radio_1 = __importDefault(require("../location-filter-radio"));
require("./styles.scss");
// export default
function SearchFilters({ currentLocation, filterItems, searchParamDefaults, setShowFilter, disableFilter, mapResultsScroll, resultsScroll }) {
    const { t } = (0, react_i18next_1.useTranslation)();
    //Initialize state filter values
    const initFilterValues = () => {
        const filtersInitial = {};
        if (filterItems) {
            for (const filter of filterItems) {
                if (filter.optionParamMap) {
                    for (const param of Object.values(filter.optionParamMap)) {
                        filtersInitial[param] = '0';
                    }
                }
            }
        }
        if (searchParamDefaults) {
            for (const [key, value] of searchParamDefaults) {
                filtersInitial[key] = value;
            }
        }
        return filtersInitial;
    };
    const [filterValues, setFilterValues] = (0, react_1.useState)(initFilterValues());
    const handleFilterChange = (param, value) => {
        setFilterValues((prev) => (Object.assign(Object.assign({}, prev), { [param]: value })));
    };
    //Update params when prop changes
    (0, react_1.useEffect)(() => {
        if (searchParamDefaults) {
            for (const [key, value] of searchParamDefaults) {
                handleFilterChange(key, value);
            }
        }
    }, [searchParamDefaults]);
    //Generate filter components
    const renderFilters = (filter) => {
        if (filter.type === models_1.Filter.Checkbox && filter.options && filter.optionParamMap) {
            return ((0, jsx_runtime_1.jsx)(location_filter_checkbox_1.default, { title: filter.title, options: filter.options, optionParamMap: filter.optionParamMap, onChange: handleFilterChange, ignoreLabel: filter.ignoreLabel, searchParamDefaults: searchParamDefaults }));
        }
        else if (filter.options && filter.optionParamMap) {
            return ((0, jsx_runtime_1.jsx)(location_filter_radio_1.default, { title: filter.title, options: filter.options, optionParamMap: filter.optionParamMap, onChange: handleFilterChange, ignoreLabel: filter.ignoreLabel, searchParamDefaults: searchParamDefaults }));
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "search-filter", style: { height: `calc(100% - 8rem)` } }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "search-filter-label" }, { children: [(0, jsx_runtime_1.jsx)("h5", { children: t('searchFilters.title') }), (0, jsx_runtime_1.jsxs)("button", Object.assign({ type: "button", className: "close", onClick: () => setShowFilter(false) }, { children: [(0, jsx_runtime_1.jsx)("svg", Object.assign({ className: "ontario-icon", "aria-hidden": "true", focusable: "false", viewBox: "0 0 24 24", preserveAspectRatio: "xMidYMid meet" }, { children: (0, jsx_runtime_1.jsx)("use", { xlinkHref: require("../../assets/ontario-icons-primary.svg") + "#ontario-icon-close" }) })), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "ontario-show-for-sr" }, { children: t('searchFilters.closeFilters') }))] }))] })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "filter-container" }, { children: (0, jsx_runtime_1.jsx)(location_accordion_1.default, { id: "primary-accordion", items: filterItems.map(f => {
                        return {
                            title: f.title,
                            body: f.type ? renderFilters(f) : f.body
                        };
                    }) }) })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "apply-filter-button" }, { children: [(0, jsx_runtime_1.jsx)("button", Object.assign({ type: "button", className: "ontario-button ontario-button--primary", id: "applyFilter", onClick: () => {
                            var _a, _b;
                            if (!disableFilter) {
                                (_a = mapResultsScroll.current) === null || _a === void 0 ? void 0 : _a.scrollTo({
                                    top: 0,
                                    left: 0,
                                    behavior: "auto",
                                });
                                (_b = resultsScroll.current) === null || _b === void 0 ? void 0 : _b.scrollTo({
                                    top: 0,
                                    left: 0,
                                    behavior: "auto",
                                });
                                (0, utils_1.doSearchBox)(currentLocation, t, new URLSearchParams(filterValues));
                                setShowFilter(false);
                            }
                        } }, { children: t('searchFilters.applyFilters') })), (0, jsx_runtime_1.jsx)("button", Object.assign({ type: "button", className: "ontario-button ontario-button--secondary", id: "applyFilterCancel", onClick: () => {
                            setShowFilter(false);
                        } }, { children: t('searchFilters.cancel') }))] }))] })));
}
exports.default = SearchFilters;
